import React, { useEffect } from 'react';
import { default as BsButton, ButtonProps as BsButtonProps } from 'react-bootstrap/Button';
import { ReplaceBsType } from '../../helpers/types';
import { Spinner } from '../loaders/Spinner';

type ClickEvent = React.MouseEvent<HTMLButtonElement> & {
  actionPromise?: Promise<any>;
};

export interface BtnProps extends Omit<ReplaceBsType<BsButtonProps>, 'size'> {
  readonly as?: any;
  readonly disabled?: boolean;
  readonly loading?: boolean;
  readonly onClick?: (evt: ClickEvent) => any;
  readonly style?: React.CSSProperties;
  readonly className?: string;
  readonly width?: string;
  readonly ref?: any;
  readonly size?: 'xs' | 'sm' | 'lg';
  readonly icon?: React.ReactNode | null;
  readonly role?: any;
  readonly title?: any;
  readonly to?: any;
  readonly htmlType?: string;
}

export const BtnP = (props: BtnProps) => {
  const {
    icon,
    children,
    onClick,
    type,
    className,
    loading: passedLoading,
    size,
    htmlType,
    ...rest
  } = props;
  const mounted = React.useRef(false);
  const [promiseActionRunning, setActionRunning] = React.useState(false);
  const loading = passedLoading || promiseActionRunning;

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const onClickUpdateState = async (evt: ClickEvent) => {
    if (!onClick) {
      return;
    }

    if (!loading) {
      const v = onClick(evt) || evt.actionPromise;

      if (v && mounted.current) {
        setActionRunning(true);
        try {
          await v;
        } finally {
          if (mounted.current) {
            setActionRunning(false);
          }
        }
      }
    }
  };

  const iconClassName = children ? 'mr-1' : 'mr-0';
  const iconEl =
    props.icon && React.isValidElement(props.icon) ? (
      <span className={iconClassName}>{props.icon}</span>
    ) : null;

  return (
    <BsButton
      className={className}
      disabled={rest.disabled || loading}
      onClick={onClickUpdateState}
      variant={type as any}
      size={size as any}
      style={{
        minWidth: props.width,
      }}
      type={htmlType}
      {...rest}
    >
      {!loading && iconEl}
      {loading && <Spinner className="mr-1" />} {children}
    </BsButton>
  );
};

BtnP.defaultProps = {
  type: 'outline-primary',
};

export const Btn = BtnP;
